import {BaseService} from "./base.service";

class StatesService extends BaseService {
    constructor() {
        super('api/states');
    }
}

export const estadoService = new StatesService();
